import CheckoutFragment from './CheckoutFragment'

export default `
${CheckoutFragment}
query ($id: ID!) {
  node(id: $id) {
    ...CheckoutFragment
  }
}`
